export default function SEOContentBottom() {
  return (
    <section className="bg-white py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Pourquoi Nous Choisir */}
        <div className="text-center mb-12 lg:mb-16">
          <span className="text-teal-600 font-semibold text-xs uppercase tracking-wider">
            POURQUOI NOUS CHOISIR
          </span>
          <h2 className="text-3xl lg:text-5xl font-extrabold text-gray-900 mt-4 mb-6">
            Nous Ne Vendons Pas de Fenêtres, Nous Les Réparons
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Spécialistes de la <strong>réparation et de l'entretien de fenêtres à Lyon</strong> depuis 2009. 
            Nous ne posons pas de fenêtres neuves, nous prolongeons la vie de vos menuiseries existantes.
          </p>
        </div>

        {/* 3 Cartes Avantages */}
        <div className="grid md:grid-cols-3 gap-6 lg:gap-8 mb-16 lg:mb-20">
          {/* Carte 1 */}
          <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-6 lg:p-8 hover:shadow-xl transition-all duration-300">
            <div className="w-full h-40 lg:h-48 mb-6 rounded-xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/79cfdc69172c31de33a6eb3c596d6461.jpg"
                alt="Certification réparation fenêtres Lyon"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Diagnostic Honnête
            </h3>
            <p className="text-sm text-gray-700 leading-relaxed mb-4">
              Nous sommes <strong>techniciens réparateurs, pas vendeurs</strong>. Notre diagnostic est objectif : si votre fenêtre est réparable (90% des cas), nous la réparons. Si elle ne l'est pas, nous vous orientons vers un poseur de confiance. <a href="#contact" className="text-teal-600 hover:text-teal-700 underline font-medium">Demandez votre diagnostic</a>.
            </p>
            <p className="text-sm text-gray-700 leading-relaxed">
              Aucun intérêt commercial à vous vendre du neuf. Notre métier : <strong>réparer et entretenir</strong>, pas remplacer.
            </p>
          </div>

          {/* Carte 2 */}
          <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-6 lg:p-8 hover:shadow-xl transition-all duration-300">
            <div className="w-full h-40 lg:h-48 mb-6 rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20european%20service%20van%20with%20window%20repair%20equipment%20parked%20in%20front%20of%20modern%20french%20residential%20building%20in%20Lyon%20showing%20quick%20professional%20intervention%20with%20tools%20and%20ladder%20ready%20for%20emergency%20window%20repair%20service&width=400&height=300&seq=seo-rapid-euro-003&orientation=landscape"
                alt="Intervention rapide réparation fenêtres Lyon"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Réparation Immédiate
            </h3>
            <p className="text-sm text-gray-700 leading-relaxed mb-4">
              <strong>Stock permanent de pièces détachées</strong> : quincaillerie, joints, mécanismes, vitrages. 80% des réparations effectuées le jour même. Intervention d'urgence 7j/7 pour les problèmes de sécurité. Voir nos <a href="#services" className="text-teal-600 hover:text-teal-700 underline font-medium">services</a>.
            </p>
            <p className="text-sm text-gray-700 leading-relaxed">
              Pas d'attente de plusieurs semaines comme pour une pose neuve. Votre fenêtre fonctionne à nouveau en quelques heures.
            </p>
          </div>

          {/* Carte 3 */}
          <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-6 lg:p-8 hover:shadow-xl transition-all duration-300">
            <div className="w-full h-40 lg:h-48 mb-6 rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=transparent%20pricing%20document%20showing%20detailed%20window%20repair%20cost%20breakdown%20with%20calculator%20and%20professional%20invoice%20demonstrating%20clear%20honest%20pricing&width=400&height=300&seq=seo-price-003&orientation=landscape"
                alt="Tarifs transparents réparation fenêtres Lyon"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Économies Garanties
            </h3>
            <p className="text-sm text-gray-700 leading-relaxed mb-4">
              La <strong>réparation coûte 3 à 5 fois moins cher</strong> qu'un remplacement complet. Nous vous proposons toujours la solution la plus économique et durable. Devis détaillé gratuit, tarifs transparents, aucune surprise. Consultez notre <a href="/blog/prix-reparation-fenetre-lyon-2025" className="text-teal-600 hover:text-teal-700 underline font-medium">guide des prix</a>.
            </p>
            <p className="text-sm text-gray-700 leading-relaxed">
              Toutes nos réparations sont garanties 2 ans pièces et main-d'œuvre. Nous utilisons exclusivement des pièces de qualité professionnelle pour assurer la durabilité de nos interventions.
            </p>
          </div>
        </div>

        <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-6 md:p-12 mb-16 lg:mb-20">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <h2 className="text-2xl lg:text-3xl font-bold text-white mb-6">
                Les Problèmes de Fenêtres Que Nous Réparons à Lyon
              </h2>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-close-circle-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-white mb-1">Fenêtre qui ne ferme plus</h4>
                    <p className="text-sm text-gray-300">
                      <a href="/remplacement-quincaillerie-fenetre-lyon" className="text-teal-400 hover:text-teal-300 underline">Réparation de quincaillerie</a>, réglage des gonds, remplacement des mécanismes de fermeture défectueux.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-drop-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-white mb-1">Infiltrations d'eau</h4>
                    <p className="text-sm text-gray-300">
                      Remplacement des joints d'étanchéité, réparation du drainage, traitement des problèmes de condensation. Voir nos conseils sur <a href="/blog/entretien-fenetres-pvc-lyon" className="text-teal-400 hover:text-teal-300 underline">l'entretien</a>.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-sound-module-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-white mb-1">Mauvaise isolation thermique/phonique</h4>
                    <p className="text-sm text-gray-300">
                      Remplacement des joints, réglage de la compression, changement de vitrage si nécessaire. En savoir plus sur <a href="/blog/isolation-thermique-fenetres-lyon" className="text-teal-400 hover:text-teal-300 underline">l'isolation</a>.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-hammer-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-white mb-1">Poignée cassée ou bloquée</h4>
                    <p className="text-sm text-gray-300">
                      Remplacement de poignées, réparation de crémones, déblocage de mécanismes grippés.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-contrast-drop-2-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-white mb-1">Vitrage fissuré ou embué</h4>
                    <p className="text-sm text-gray-300">
                      Remplacement de vitrages simple ou <a href="/blog/fenetres-double-vitrage-lyon" className="text-teal-400 hover:text-teal-300 underline">double vitrage</a>, réparation de parcloses.
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-8">
                <a
                  href="#contact"
                  className="inline-flex items-center space-x-3 bg-teal-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-teal-700 transition-all hover:shadow-xl whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-tools-line text-xl"></i>
                  <span>Demander une Réparation</span>
                </a>
              </div>
            </div>

            <div className="w-full h-80 lg:h-96 rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20window%20repair%20technician%20actively%20repairing%20broken%20window%20mechanism%20with%20precision%20tools%20close%20up%20hands%20working%20on%20window%20hardware%20detailed%20repair%20work%20in%20progress%20showing%20expertise%20and%20craftsmanship%20bright%20clean%20workspace&width=600&height=700&seq=seo-repair-tech-004&orientation=portrait"
                alt="Technicien réparant une fenêtre à Lyon"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        {/* Zone d'Intervention */}
        <div>
          <div className="text-center mb-10 lg:mb-12">
            <h2 className="text-2xl lg:text-4xl font-extrabold text-gray-900 mb-4">
              Zone d'Intervention Grand Lyon
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Nous intervenons pour la <strong>réparation de fenêtres</strong> dans tout le Grand Lyon et les communes limitrophes.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
            <div className="bg-teal-50 rounded-xl p-5 lg:p-6">
              <h3 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                <i className="ri-map-pin-line text-teal-600"></i>
                Lyon Centre
              </h3>
              <p className="text-sm text-gray-700">
                1er, 2e, 3e, 4e, 5e, 6e, 7e, 8e, 9e arrondissements
              </p>
            </div>

            <div className="bg-teal-50 rounded-xl p-5 lg:p-6">
              <h3 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                <i className="ri-map-pin-line text-teal-600"></i>
                Est Lyonnais
              </h3>
              <p className="text-sm text-gray-700">
                Villeurbanne, Bron, Vénissieux, Vaulx-en-Velin, Décines
              </p>
            </div>

            <div className="bg-teal-50 rounded-xl p-5 lg:p-6">
              <h3 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                <i className="ri-map-pin-line text-teal-600"></i>
                Ouest Lyonnais
              </h3>
              <p className="text-sm text-gray-700">
                Écully, Tassin, Sainte-Foy-lès-Lyon, Francheville, Oullins
              </p>
            </div>

            <div className="bg-teal-50 rounded-xl p-5 lg:p-6">
              <h3 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                <i className="ri-map-pin-line text-teal-600"></i>
                Nord & Sud
              </h3>
              <p className="text-sm text-gray-700">
                Caluire, Rillieux, Meyzieu, Saint-Priest, Givors
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
